import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { changes } from "src/components/utils/fields";
import { useMediaQuery } from "@mui/material";
import {
  BufferService,
  LoadingContext,
  NavigateContext,
  M_Button,
  M_Fieldset,
  M_Header,
  M_MessageBoard,
} from "src/M_Components";
import { Info, Refresh } from "@mui/icons-material";
import { QuoteInfo } from "./components/QuoteInfo";
import { QuoteDates } from "./components/QuoteDates";
import { QuotePorts } from "./components/QuotePorts";
import { QuoteEntities } from "./components/QuoteEntities";
import { QuoteEquipment } from "./components/QuoteEquiment";
import { QuoteGoods } from "./components/QuoteGoods";
import { QuoteCalculator } from "./components/QuoteCalculator";
import { QuoteCharges } from "./components/QuoteCharges";
import { QuoteFormField } from "./components/QuoteFormField";

export const ApproveQuoteDetail = ({ roles }) => {
  const [id, setId] = useState(sessionStorage.getItem("selectedTab"));
  const { t } = useTranslation();
  const ctx = useContext(LoadingContext);
  const navigateCtx = useContext(NavigateContext)
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [passedRow, setPassedRow] = useState({});
  const [operation, setOperation] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [triggerAddNewCharge, setTriggerAddNewCharge] = useState(false);

  const [showRejectDialog, setShowRejectDialog] = useState(false)

  const accountService = new BufferService("Account");
  // const quoteService = new BufferService("Quote");
  const quoteGetRequestService = new BufferService("quotegetrequest");
  const quoteCreateRequestService = new BufferService("quotecreaterequest");
  const quoteUpdateRequestService = new BufferService("quoteupdaterequest");

  const sessionKeys = ["operation", "data", "open", "passedRow"];

  const matches11 = useMediaQuery("(min-width:970px)");
  const matches12 = useMediaQuery("(min-width:930px)");
  const matches16 = useMediaQuery("(min-width:440px)");

  useEffect(() => {
    if (isFirstTime) {
      ctx.setIsLoad(true);
      getSessionStorageData(id);
      setIsFirstTime(false);
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
    }
  }, []);

  useEffect(() => {
    const passOperation = ctx.passValue.get("operation");
    setOperation(passOperation);
  }, []);

  useEffect(() => {
    const newId = sessionStorage.getItem("selectedTab");
    if (newId !== id) {
      setId(newId);
      getSessionStorageData(newId);
    }
  }, []);

  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key);
    });
    // eslint-disable-next-line
  }, [id, operation, data]);

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0)
      return;
    if (eval(value) instanceof String && eval(value) === "") return;
    if (eval(value) instanceof Number && eval(value) === "") return;

    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      sessionStorage.setItem(
        `${id}${key}`,
        JSON.stringify(Array.from(eval(value))),
      );
    } else {
      // eslint-disable-next-line
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)));
    }
  };

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true);
    const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`));
    const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`));
    const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`));
    const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`));

    if (
      (tempO && tempO !== "") ||
      (tempD && Object.keys(tempD).length !== 0) ||
      tempOS ||
      (tempPR && Object.keys(tempD).length !== 0)
    ) {
      setOperation(new String(tempO));
      setData(new Object(tempD));
      setOpen(tempOS);
      setPassedRow(tempPR);
      ctx.setIsLoad(false);

      return;
    }
    get();
  };

  const fixResponseObject = (obj) =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.charAt(0).toLowerCase() + key.slice(1),
        value,
      ]),
    );

  const fixResponseListObject = (obj) =>
    obj.map((element) =>
      Object.fromEntries(
        Object.entries(element).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.slice(1),
          value,
        ]),
      ),
    );

  const get = () => {
    const row = ctx.passValue.get("Row")

    if (row) {
      const lines = ctx.passValue.get('Row')
      const tempId = lines.Id
      console.log("1", tempId)
      quoteGetRequestService.getId(tempId).then((response) => {
        if (response.name === "AxiosError") {
          ctx.toastMessages(
            "error",
            t("Error"),
            response?.response?.data?.Errors || response.message,
          );
          ctx.setIsLoad(false);
          return;
        }
        console.log("ddddddd", response)

        const fixedQuoteResponse = fixResponseObject(response.Quote);
        const fixedGoodsResponse = fixResponseListObject(response.Goods);
        const fixedEquipmentResponse = fixResponseListObject(
          response.Equipment,
        );
        const fixedChargesResponse = response.Charges ? fixResponseListObject(response.Charges) : [];
        const fixedChargesResponseWithId = fixedChargesResponse.map((value, index) => ({ ...value, id: index }))

        delete fixedQuoteResponse.Goods;
        delete fixedQuoteResponse.Equipment;
        delete fixedQuoteResponse.Charges;

        const fixedQuoteResponseDates = {
          ...fixedQuoteResponse,
          startDate: fixedQuoteResponse.startDate?.split("T")[0],
          dueDate: fixedQuoteResponse.dueDate?.split("T")[0],
          expireDate: fixedQuoteResponse.expireDate?.split("T")[0],
        };

        const fixedEquipmentTypesResponse = fixedEquipmentResponse.map(
          (equipment) => ({
            ...equipment,
            equipmentType: `${equipment["equipmentTypeLenght"]}${equipment["equipmentTypeCode"]}`,
          }),
        );

        const fixedAllResponses = {
          ...fixedQuoteResponseDates,
          Goods: fixedGoodsResponse,
          Equipments: fixedEquipmentTypesResponse,
          charges: fixedChargesResponseWithId,
          isApprovePage: true,
        };

        setData(fixedAllResponses);
        changes(
          "counterCharges",
          fixedAllResponses.charges.length,
          setData,
        );
        
        changes(
          "GoodsCounter",
          fixedAllResponses.Goods.length,
          setData,
        );

        ctx.setIsLoad(false);
      })
        .catch((err) => {
          ctx.toastMessages("error", err.message, "Error");
          ctx.setIsLoad(false);
        });
    } else {
      changes("counterCharges", 0, setData);
      if (ctx.passValue.get("Rows")?.length > 1) {
        setData({ ...data, isMultiEdit: true });
      }
    }

    changes("totalCurrency", "€", setData);

    getCompanies();
    ctx.setIsLoad(false);
  };

  const getCompanies = () => {
    let tempCompanies = JSON.parse(sessionStorage.getItem("companies"));
    if (tempCompanies.length === 0) {
      ctx.toastMessages("error", "User has no companies!", "");
    }
    if (tempCompanies.length === 1) {
      getAccount(tempCompanies[0]);
    }

    changes(
      "companyOptions",
      tempCompanies.map((field) => {
        return { label: field.Name, value: field.AccountId, ...field };
      }),
      setData,
    );
  };

  const getAccount = (accountId) => {
    if (accountId) {
      accountService.getId(accountId).then((res) => {
        if (res.name === "AxiosError") {
          ctx.toastMessages("error", "Couldnt fetch Account!", "");
          return;
        }
        changes("clientCode", res.AccountCode, setData);
        changes("clientVat", res.AccountVATNumber, setData);
      });
    } else {
      changes("clientCode", "", setData);
      changes("clientVat", "", setData);
    }
  };

  const onSave = (status) => {
    const tempCharges = data.charges?.map((obj) => {
      const { id, ...rest } = obj;
      return rest;
    });

    if (!data.Equipments) data.Equipments = [];

    const tempEquipments = data.Equipments?.map((obj) => {
      const { Id, equipmentType, ...rest } = obj;
      return rest;
    });

    const tempGoods = data.Goods?.map((obj) => {
      const { Id, ...rest } = obj;
      return rest;
    });

    const rows = ctx.passValue.get("Rows")

    const saveData = {
      Equipments: tempEquipments,
      Goods: tempGoods,
      Charges: tempCharges,
      Quote: status ? { ...data, Status: status } : data,
      IsMultiEdit: data.isMultiEdit,
      MultiEditQuoteIds: rows?.map((x) => x.Id),
    };
    ctx.setIsLoad(true);
    quoteUpdateRequestService.update(data.id, saveData).then((response) => {
      if (response.name === "AxiosError") {
          const data = response?.response?.data

          ctx.toastMessages(
            "error",
            t("ErrorUpdating"),
            data !== null && data !== undefined ? Object.values(data).flat().join("\n") || response.message : "",
          );
          ctx.setIsLoad(false);
      } else {
          ctx.toastMessages(
              "success",
              t("Success"),
              t("EditedQuote"),
          );
          ctx.setIsLoad(false);
          navigateCtx.closeTab(id.replace(/"/g, ''))
      }
  });
};

  return (
    <div>
      <M_Header
        element={
          <>
            <M_Button
              tooltip={t("Refresh")}
              icon={<Refresh />}
              label={t("Refresh")}
              onClick={() => get()}
            />
            <M_Button
              tooltip={t("AcceptQuote")}
              icon={<img src='\icons\svgsDaNet\check-circle.svg' style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '20px' }} alt='AcceptQuote' />}
              label={t("AcceptQuote")}
              onClick={() => onSave("A")}
            />
            <M_Button
              tooltip={t("RejectQuote")}
              icon={<img src='\icons\svgsDaNet\x-circle.svg' style={{ filter: 'invert(8%) sepia(94%) saturate(6897%) hue-rotate(3deg) brightness(108%) contrast(110%)', width: '20px' }} alt='RejectQuote' />}
              label={t("Reject")}
              onClick={() => setShowRejectDialog(true)}
            />
          </>
        }
      />
      <div style={{ margin: "20px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: (!matches11 && "auto ") || "auto auto auto",
          }}
        >
          <QuoteInfo dataState={data} setDataState={setData} />
          <QuoteDates dataState={data} setDataState={setData} />
          <QuotePorts dataState={data} setDataState={setData} />
        </div>
        <div>
          <QuoteEntities dataState={data} setDataState={setData} />
        </div>
        <div
          style={{
            display: (!matches16 && "flex") || "grid",
            flexDirection: "column",
            gridTemplateColumns: (!matches12 && "auto") || "auto auto",
          }}
        >
          <QuoteEquipment dataState={data} setDataState={setData} />
          <QuoteGoods dataState={data} setDataState={setData} />
        </div>
        <QuoteCharges
          dataState={data}
          setDataState={setData}
          passedRowState={passedRow}
          setPassedRowState={setPassedRow}
          triggerAddNewCharge={triggerAddNewCharge}
        />
        <div style={{ margin: "25px" }}></div>
        <QuoteCalculator dataState={data} setDataState={setData} />
      </div>
      <M_MessageBoard
        open={showRejectDialog}
        onClose={() => setShowRejectDialog(false)}
        title={t("LabelRejectBooking")}
        body={
          <>
            <QuoteFormField
              fields={{
                display: t("Reason"),
                code: "rejectReason",
                type: "textArea",
                required: true,
              }}
              data={data}
              setData={setData}
              size={400}
            />
            {/* <M_TextArea
              label={t("Notes")}
              value={finalNotes}
              onChange={(e) => setFinalNotes(e.target.value)}
            /> */}
          </>
        }

        footer={
          <div style={{ display: 'flex' }}>
            <M_Button
              normal
              hoverEffect
              label={t("ButtonCancel")}
              backgroundColor={'var(--color-red)'}
              labelColor={'var(--color-white)'}
              onClick={() => setShowRejectDialog(false)}
            />
            <M_Button
              normal
              hoverEffect
              label={t("ConfirmReject")}
              backgroundColor={'var(--color-green)'}
              labelColor={'var(--color-white)'}
              onClick={() => onSave("X")}
            />
          </div>
        }
    />
      {/* <M_MessageBoard
        warning
        open={showRejectDialog}
        onClose={() => setShowRejectDialog(false)}
        title={t("RejectQuote")}
        body={
          <QuoteFormField
            fields={{
              display: t("Reason"),
              code: "rejectReason",
              type: "text",
              required: true,
            }}
            data={data}
            setData={setData}
          />
        }
        footer={
          <div style={{ display: 'flex' }}>
            <M_Button
                normal
                hoverEffect
                label={t("ButtonCancel")}
                backgroundColor={'var(--color-red)'}
                labelColor={'var(--color-white)'}
                onClick={() => setShowRejectDialog(false)}
            />
            <M_Button
                normal
                hoverEffect
                label={t("Delete")}
                backgroundColor={'var(--color-green)'}
                labelColor={'var(--color-white)'}
                onClick={() => onSave("X")}
            />
          </div>
        }
    /> */}
    </div>
  );
};
